import {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getAllInpatientHospital, getAllInpatientProcedure, getAllInpatientSchedule} from '../Redux/Thunk/inPatientScheduleActions';

const useInPatient = (filters, pagination, loaderchange, popupalert, popuptext) => {
  const [dataCount, setDataCount] = useState(0);
  const [tableData, setTableData] = useState([]);

  const dispatch = useDispatch();

  const procedures = useSelector(state => state.inPatientSchedule.procedures);
  const hospitals = useSelector(state => state.inPatientSchedule.hospitals);

  useEffect(() => {
    dispatch(getAllInpatientProcedure());
    dispatch(getAllInpatientHospital());
  }, [dispatch]);

  const prevData = useRef(null);

  const fetchData = useCallback(async () => {
    const dataPayload = {
      page: pagination.pageIndex,
      page_size: pagination.pageSize,
      search: filters.search,
      procedure: filters.procedure || '',
      hospital: filters.hospital || '',
      status: filters.status || '',
      payment_status: filters.payment_status || '',
      admission_date_after: filters.admission_date_after || '',
      admission_date_before: filters.admission_date_before || ''
    };

    if (JSON.stringify(prevData.current) === JSON.stringify(dataPayload)) return;
    prevData.current = dataPayload;
    loaderchange('true');

    try {
      const data = await dispatch(getAllInpatientSchedule(dataPayload)).unwrap();
      const inPatient = data.data;
      if (inPatient.length > 0) {
        setTableData(inPatient);
        setDataCount(data.total_count);
      } else {
        popupalert('true');
        setTableData([]);
        setDataCount(0);
        popuptext('No Data Available');
        setTimeout(() => popupalert('false'), 2000);
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      popupalert('true');
      popuptext('Failed to fetch data');
      setTimeout(() => popupalert('false'), 2000);
    } finally {
      loaderchange('false');
    }
  }, [filters, pagination]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {procedures, hospitals, tableData, dataCount};
};

export default useInPatient;
